/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { isArrayNotEmpty } from "utils/empty-exists";

const EmbedFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};

    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) &&
                values.map((item, index) => {
                    const { value } = item || {};
                    // const { html, script, isResponsive, enableScript } = value || {}
                    const { html } = value || {};
                    return value &&
                        <Fragment key={index}>
                            <div dangerouslySetInnerHTML={{ __html: html }} />
                        </Fragment>;
                }
                )
            }
        </FieldDisplayWrapper>
    );
};
EmbedFieldDisplay.displayName = "EmbedFieldDisplay";
export { EmbedFieldDisplay };
